module.exports = __webpack_public_path__ + "static/media/pngwave.8eb01c0a.png";